import { render, staticRenderFns } from "./ItemFilterPremiumMyFilter.vue?vue&type=template&id=32f77bca&scoped=true"
import script from "./ItemFilterPremiumMyFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterPremiumMyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f77bca",
  null
  
)

export default component.exports